<template>
  <div class="organization-startups-funnel">
    <h4>Funnel</h4>

    <Board
      :columns="columns"
      :columns-draggable="false"
      :cards="funnelItems"
      column-card-key="investor_state"
      @card-drop="onCardDrop"
    >
      <div slot-scope="{ card }" class="startup-card card">
        <div
          class="startup-card-content"
          @click.prevent="onCardClick({ card })"
        >
          <div class="startup-card-logo">
            <div
              v-if="card.logo_url"
              class="img-cropped centered"
              :style="{
                'background-image': `url(${getLogoUrl(card.logo_url)})`,
              }"
            />
            <img-placeholder
              v-else
              class="img-responsive centered"
              width="50"
              height="50"
            />
          </div>
          <div class="startup-card-main">
            <h6>{{ card.name }}</h6>
          </div>
        </div>
      </div>
    </Board>
    <router-view />
  </div>
</template>

<script>
import { stateByValue } from '@/services/startup-classification'
import { cloudinaryTransform } from '@/filters'

export default {
  data() {
    return {
      orgId: null,
    }
  },
  computed: {
    columns() {
      return ['screening', 'interested', 'in_contact', 'investment'].map(
        (value) => stateByValue[value],
      )
    },
    funnelItems() {
      const items = this.$store.state.organizationStartupsFunnel.entries
      return items.map((item) => {
        return {
          ...item,
          columnValue: item.state,
        }
      })
    },
  },
  async created() {
    const user = await this.$store.dispatch('user/getUser')
    this.orgId = user.organizationId
    this.investorId = user.investor ? user.investor.id : null
    this.fetch()

    if (user.investor) {
      this.$store.commit(
        'startupProfileInvestorClassifies/setInvestor',
        user.investor,
      )
    }
  },
  methods: {
    getLogoUrl(url) {
      return cloudinaryTransform(url, { w: 50, h: 50, c: 'limit' })
    },
    async fetch() {
      this.$store.dispatch('organizationStartupsFunnel/fetch', {
        investorId: this.investorId,
      })
    },
    onCardDrop({ column, card, columnCards, removedIndex, addedIndex }) {
      if (removedIndex === addedIndex) {
        return
      }

      if (
        (removedIndex !== null && addedIndex !== null) ||
        (addedIndex !== null && column !== card.state)
      ) {
        let prevCard, nextCard, pos
        const newColumnCards = columnCards.map((item) => item) // copy

        const stateChanged = card.state !== column && addedIndex !== null
        if (stateChanged) {
          this.$store.dispatch('organizationStartupsFunnel/setState', {
            id: card.id,
            newState: column,
          })
        } else {
          newColumnCards.splice(removedIndex, 1)
        }
        newColumnCards.splice(addedIndex, 0, card)

        const startupsOrder = newColumnCards.map((card, idx) => card.startup_id)
        this.$store.dispatch('startupProfileInvestorClassifies/classify', {
          investorId: this.investorId,
          startupId: card.startup_id,
          value: column,
          startupsOrder,
        })
        this.$store.dispatch('organizationStartupsFunnel/setStartupsOrder', {
          startupsOrder,
        })
        const names = newColumnCards.map((card, idx) => card.name)
      }
    },
    onCardClick({ card }) {
      this.$router.push({
        name: 'organizationFunnelStartup',
        params: { startupId: card.startup_id },
      })
    },
  },
}
</script>

<style lang="scss">
@import '~assets/css/colors.scss';

.organization-startups-funnel {
  .startup-card {
    background-color: $white;
    box-shadow: 1px 1px 2px 0px $grey90;

    .startup-card-content {
      display: flex;
      align-items: center;
      height: 80px;
      padding: 5px;
      margin: 0px;

      .startup-card-logo {
        width: 50px;
        height: 50px;
        -webkit-border-radius: 25px;
        -moz-border-radius: 25px;
        border-radius: 50%;
        box-shadow: 0 0 1px $grey90;

        .img-cropped {
          background-repeat: no-repeat;
          background-position: center;
          background-size: contain;
          width: 50px;
          height: 50px;
          -webkit-border-radius: 25px;
          -moz-border-radius: 25px;
          border-radius: 50%;
        }
      }

      .startup-card-main {
        margin-left: 5px;
      }
    }
  }
}
</style>
